import {mock} from './index';
import {api} from '../components/Base/App';
import * as ObjectConst from '../constants/Property';
import * as ActionTypes from '../constants/ActionTypes';


export default {
    getObjects(requestParams) {
        const params = new URLSearchParams();
        params.append('statuses', ObjectConst.STATUS.ACTIVE);

        Object.entries(requestParams)
            .filter(elem => elem[1] !== undefined)
            .forEach(elem => {
                params.append(elem[0], elem[1]);
            });

        return api({
            method: 'get',
            url: '/rest/objects',
            params: params
        });
    },

    getObjectById(id, embed) {
        const params = new URLSearchParams();

        embed.forEach(element => {
            params.append('embed', element);
        });

        return api({
            method: 'get',
            url: '/rest/objects/' + id,
            params: params
        });
    },

    callbackRequest(objectId, phoneNumber) {
        if (process.env.NODE_ENV === 'development') {
            mock.onGet().reply(204);
        }

        return api({
            method: 'get',
            url: `/rest/objects/${objectId}/callback`,
            params: {
                phoneNumber: phoneNumber
            }
        });
    },

    requestForPurchase(objectId, userId) {
        if (process.env.NODE_ENV === 'development') {
            mock.onGet().reply(204);
        }

        return api({
            method: 'get',
            url: `/rest/objects/${objectId}/request-for-purchase`,
            params: {
                userId: userId
            }
        });
    },

    // перенести в другой пакет
    bookingRequest(propertyId, bookingRequestParams) {
        if (process.env.NODE_ENV === 'development') {
            mock.onGet().reply(204);
        }

        return api({
            method: 'post',
            url: '/rest/api/bookit',
            params: {
                propertyId: propertyId,
                start: bookingRequestParams.dateStart,
                end: bookingRequestParams.dateEnd,
                countGuest: bookingRequestParams.countGuests
            }
        });
    },

    emailSendRequest(message, subject, recipientEmail) {
        if (process.env.NODE_ENV === 'development') {
            mock.onGet().reply(204);
        }

        return api({
            method: 'post',
            url: '/rest/objects/email-send',
            data: {
                message: message,
                subject: subject,
                recipientEmail: recipientEmail
            }
        });
    },

    createObject(objectCreateCommand) {
        const {
            props = {},
            price = {},
            other = {},
            location = {},
            amenities = {},
            description = {},
            userAddress = {},
            characteristics = {}
        } = objectCreateCommand;

        const {
            ref,
            area = 0,
            authorId,
            terrace = 0,
            countBeds = 0,
            countGuest = 0,
            countBedrooms = 0,
            countBathrooms = 0,
            type = ObjectConst.TYPE.RENT,
            status = ObjectConst.STATUS.DRAFT,
            typeTerm = ObjectConst.TYPE_TERM.HOLIDAY,
            rangeType = ObjectConst.RANGE_TYPE.OTHER,
            sourceType = ObjectConst.SOURCE_TYPE.USER,
            typeApartment = ObjectConst.TYPE_APARTMENT.APARTMENT,
            cancellationRule = ObjectConst.TYPE_RULE_RESERVATION.SIMPLE,
        } = props;

        const {
            displayName = '',
            rentComment = '',
            description: descriptionValue = ''
        } = description;

        const {
            deposit = 0,
            cleaning = 0,
            priceSell = 0,
            priceRentLong = 0,
            priceRentBase = 0,
            baseMinNights = 0,
            maxStay = 0,
            currency = ObjectConst.CURRENCY.EUR.value
        } = price;

        const {
            newType = ObjectConst.NEW_TYPE.NEW,
            views = ObjectConst.VIEWS.MOUNTAINS,
            kitchen = ObjectConst.KITCHEN.MODERN,
            condition = ObjectConst.CONDITION.EXCELLENT,
            orientation = ObjectConst.ORIENTATION.SOUTH
        } = characteristics;

        const {
            yearOfConstruction = 0,
            floor = ObjectConst.FLOOR.LOWER,
            pool = ObjectConst.POOL.COMMUNAL,
            garage = ObjectConst.GARAGE.NONE,
            garden = ObjectConst.GARDEN.NONE,
            lifestyle = ObjectConst.LIFESTYLE.BEACHSIDE
        } = other;

        const {
            latitude = null,
            longitude = null,
            fixMarker = null
        } = location;

        const {
            city = null,
            index = null,
            street = null,
            country = null,
            province = null,
            streetNum = null,
            apartment = null,
            autocomplete = null
        } = userAddress;

        const data = {
            props: {
                ref: ref,
                area: area,
                type: type,
                status: status,
                terrace: terrace,
                authorId: authorId,
                typeTerm: typeTerm,
                rangeType: rangeType,
                countBeds: countBeds,
                countGuest: countGuest,
                sourceType: sourceType,
                countBedrooms: countBedrooms,
                typeApartment: typeApartment,
                countBathrooms: countBathrooms,
                cancellationRule: cancellationRule,
                checkInEndTime: "FLEXIBLE",
                checkOutTime: "TWELVE",
                checkInStartTime: "FLEXIBLE"
            },
            description: {
                displayName: displayName,
                rentComment: rentComment,
                description: descriptionValue
            },
            price: {
                deposit: deposit,
                cleaning: cleaning,
                currency: currency,
                priceSell: priceSell,
                priceRentLong: priceRentLong,
                priceRentBase: priceRentBase,
                baseMinNights: baseMinNights,
                maxStay: maxStay
            },
            amenities: [],
            characteristics: {
                pool: pool,
                floor: floor,
                garage: garage,
                garden: garden,
                lifestyle: lifestyle,
                yearOfConstruction: yearOfConstruction
            },
            other: {
                views: views,
                newType: newType,
                kitchen: kitchen,
                condition: condition,
                orientation: orientation
            },
            location: {
                latitude: latitude,
                longitude: longitude,
                fixMarker: fixMarker
            },
            userAddress: {
                city: city,
                index: index,
                street: street,
                country: country,
                province: province,
                streetNum: streetNum,
                apartment: apartment,
                autocomplete: autocomplete
            }
        };

        return api({
            method: 'post',
            url: '/rest/objects',
            data: data
        });
    },

    updateField(objectId, updateFieldCommand) {
        return api({
            method: 'put',
            url: `/rest/objects/${objectId}/updateField`,
            data: updateFieldCommand
        });
    },

    addImages(objectId, images, dispatch) {
        const formData = new FormData();

        Object.entries(images).forEach(item => {
            formData.append('file', item[1]);
        });

        return api({
            method: 'post',
            url: `/rest/objects/${objectId}/images`,
            headers: {
                'content-type': 'multipart/form-data'
            },
            data: formData,
            onUploadProgress: event => {
                if (dispatch !== undefined && event.lengthComputable) {
                    dispatch({
                        type: ActionTypes.SET_PROGRESS_BAR_INFO,
                        payload: {
                            loaded: event.loaded,
                            total: event.total
                        }
                    });
                }
            }
        });
    },

    deleteImage(objectId, imageId) {
        return api({
            method: 'delete',
            url: `/rest/objects/${objectId}/images/${imageId}`
        });
    },

    updateImages(objectId, imagesUpdateCommand) {
        return api({
            method: 'put',
            url: `/rest/objects/${objectId}/images`,
            data: imagesUpdateCommand
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/Objects.js